export default __webpack_public_path__ + "static/media/gitC.5e0e5b87.webp";